import { render, staticRenderFns } from "./VueBootstrapTypeahead.vue?vue&type=template&id=a0e87de4&scoped=true"
import script from "./VueBootstrapTypeahead.vue?vue&type=script&lang=js"
export * from "./VueBootstrapTypeahead.vue?vue&type=script&lang=js"
import style0 from "./VueBootstrapTypeahead.vue?vue&type=style&index=0&id=a0e87de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e87de4",
  null
  
)

export default component.exports